import React, { Component } from 'react';
import "./css/projectbox.css";

class Projectbox extends Component {

    state = {
        expanded: false,
        overflow: false
    }

    textRef = React.createRef();

    componentDidMount() {
        const el = this.textRef.current;
        if (el.scrollHeight > el.clientHeight) {
            this.setState({ overflow: true });
        }
    }

    toggleText = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        return (
            <div className="project-card">
                <div className="project-card-body">
                    <h5>{this.props.title}</h5>

                    <p
                        ref={this.textRef}
                        className={`description ${this.state.expanded ? "expanded" : ""}`}
                    >
                        {this.props.description.split("\n").map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </p>

                    {this.state.overflow && (
                        <span
                            className="toggle-text"
                            onClick={this.toggleText}
                        >
                            {this.state.expanded ? "Weniger anzeigen" : "Mehr anzeigen"}
                        </span>
                    )}
                </div>

                <div className="project-card-bottom">
                    <button
                        className="btn btn-primary"
                        disabled={!this.props.github}
                        onClick={() => this.props.onSourceCodeClick(this.props.github)}
                    >
                        Source Code
                    </button>
                </div>
            </div>
        );
    }
}

export default Projectbox;